import React, {useContext, useEffect, useState} from 'react';
import {
    ReactComponent as FoggyBackgroundIco
} from "../../../../../images/backgrounds/promotion/promotion-foggy-background.svg";
import {RootState} from "../../../../../reducers";
import {connect} from "react-redux";
import {useTranslation, withTranslation} from "react-i18next";
import {getCart} from "../../../../services/Cart/reducer";
import {ApiError} from "../../../../services/Api/types";
import handleException from "../../../../services/Api/handleException";
import {useCart} from "../../../../services/Cart/cartService";
import {VoucherProductsContext} from "../../../../services/VoucherProducts/VoucherProductsContext";
import {ReactComponent as TrashIco} from "../../../../../images/icons/trash-can.svg";
import {ReactComponent as RemoveIco} from "../../../../../images/icons/remove.svg";
import ErrorFormView from "../../../../components/Common/ErrorFormView";

interface OwnProps {
    singleItem: boolean;
}

type Props = ReturnType<typeof mapStateToProps> & OwnProps;

const MenuPromotionCoupon = ({singleItem, cart}: Props) => {
    const [errors, setErrors] = useState<ApiError[]>([]);
    const {t} = useTranslation();
    const [couponValue, setCouponValue] = useState(cart.coupon ?? "");
    const [loading, setLoading] = useState(false);
    const cartService = useCart();
    const {handlePromotionChange} = useContext(VoucherProductsContext);

    useEffect(() => {
        if (!cart.coupon && couponValue) {
            setCouponValue("");
        } else if (!couponValue && cart.coupon) {
            setCouponValue(cart.coupon);
        }
    }, [cart.coupon]);

    const handleSetCouponErrors = (errors: ApiError[]) => {
        setErrors(errors.map(error => {
            return {
                ...error,
                field: "code"
            }
        }));
    }

    const handleSubmit = async () => {
        setLoading(true);
        try {
            const response = await cartService.updateOrderCoupon({
                code: couponValue
            });
            setErrors([]);
            const couponFromResponse = response.promotions.find((promotion: any) => promotion.metadata?.toLocaleUpperCase() === `CODE_${couponValue.toLocaleUpperCase()}` && promotion.type !== "COUPON");
            await handlePromotionChange(couponFromResponse?.promotion_id);
        } catch (error: any) {
            const errors = handleException(error);
            handleSetCouponErrors(errors);
        }
        setLoading(false);
    }

    const handleRemove = async () => {
        setLoading(true)
        try {
            await cartService.updateOrderCoupon({
                code: ""
            });
            setCouponValue("");
            setErrors([]);
        } catch (error: any) {
            const errors = handleException(error);
            handleSetCouponErrors(errors);
        }
        setLoading(false)
    }

    const drawTitle = () => {
        if (errors.length > 0) {
            return <ErrorFormView errors={errors} field="code"/>;
        }

        if (cart.coupon) {
            return <p className="mb-0 success">{t("modules.menu.field.active_coupon.title")}</p>;
        }

        return <p className="mb-0">{t("modules.menu.field.coupon_code.title")}</p>;
    }

    return (
        <div className={`btn btn-promotion btn-promotion-with-coupon ${singleItem ? "single" : ""}`}>
            <FoggyBackgroundIco className="foggy-ico keep-original-color"/>
            {drawTitle()}
            <div className="d-flex gap-2 mt-2 w-100">
                <div className="input-search w-100">
                    <input type="text"
                           onChange={(event) => setCouponValue(event.target.value)} value={couponValue}
                           className="form-control w-100"
                           placeholder={t("modules.menu.field.coupon_code.placeholder")}
                           disabled={cart.coupon && errors.length === 0}
                    />
                    {
                        couponValue && !cart.coupon && (
                            <div role="button" aria-label={t("common.action.remove")} className="right text-muted"
                                 onClick={() => setCouponValue("")}>
                                <RemoveIco aria-hidden="true"/>
                            </div>
                        )
                    }
                </div>
                {
                    cart.coupon && errors.length === 0 ? (
                        <button className={"btn btn-default btn-icon"} onClick={handleRemove}
                                aria-label={t("modules.menu.action.remove_coupon.title")}>
                            <TrashIco aria-hidden="true"/>
                        </button>
                    ) : (
                        <button className={"btn btn-primary btn-spinner" + (loading ? ' loading' : '')}
                                type="button" id="cart-coupon" disabled={loading || !couponValue}
                                onClick={handleSubmit}>
                            <span className="left spinner-border spinner-border-sm me-1"/>
                            {t("common.action.ok")}
                        </button>
                    )
                }
            </div>
        </div>
    )
}

const mapStateToProps = (state: RootState) => ({
    cart: getCart(state.cart),
})

const connector = connect(mapStateToProps);
export default withTranslation()(connector(MenuPromotionCoupon));
